import type { OrderStateEventParams } from '@/services/admin/auditService'

export const orderConsistencyQueryKeys = {
  stateEvents: (mode: string, params: OrderStateEventParams) => [
    'admin',
    'order-state-events',
    mode,
    params,
  ] as const,
  sideEffectSummary: (mode: string) => [
    'admin',
    'order-side-effect-jobs',
    'summary',
    mode,
  ] as const,
  sideEffectJobs: (mode: string, params: Record<string, unknown>) => [
    'admin',
    'order-side-effect-jobs',
    'list',
    mode,
    params,
  ] as const,
  orderSideEffectJobs: (
    mode: string,
    orderId: string | null,
    params: Record<string, unknown>
  ) => ['admin', 'orders', 'side-effect-jobs', mode, orderId, params] as const,
  stateConsistency: (mode: string, orderId: string | null) => [
    'admin',
    'orders',
    'state-consistency',
    mode,
    orderId,
  ] as const,
  addressDoubleCheck: (mode: string, orderId: string | null) => [
    'admin',
    'orders',
    'address-double-check',
    mode,
    orderId,
  ] as const,
  solanaGovernanceState: (mode: string, orderId: string | null) => [
    'admin',
    'orders',
    'solana-governance-state',
    mode,
    orderId,
  ] as const,
}
